// Recovered compiled webpack factory 60861. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function n(e) {
    let { ampFirst: t = !1, hybrid: n = !1, hasQuery: r = !1 } = void 0 === e ? {} : e;
    return t || (n && r);
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "isInAmpMode", {
      enumerable: !0,
      get: function () {
        return n;
      },
    }));
}
